import utils from "../utils";

function init() {
	setGlobalVariables();
	makeElementSquare();
	detectUrlChange();
}

function setGlobalVariables(){

	setContainerMarginVariable();
	setRealVhValue();

	window.addEventListener('resize', () => {
		
		setContainerMarginVariable();
		makeElementSquare();
		setRealVhValue();
		
	});

}

function detectUrlChange(){
	var prevUrl = undefined;
	setInterval(() => {
		var currUrl = window.location.href;

		if (currUrl != prevUrl) {
			prevUrl = currUrl;
			makeElementSquare();
		}

	}, 60);
}

function makeElementSquare(){

	var squares = document.querySelectorAll(".squares, .square");

	if (squares.length > 0) {
		utils.forEach(squares, function (index, square) {
			var squareWidth = square.offsetWidth;
			square.style.height = squareWidth + "px";
		});
	}
}

function setContainerMarginVariable(){

	var container = document.querySelector('.container');
	if(container){
		var style = container.currentStyle || window.getComputedStyle(container),
			marginLeft = style.marginLeft,
			width = style.width;

		if(!marginLeft){
			marginLeft = 0;
		}

		document.documentElement.style.setProperty('--smx-container-margin', `${marginLeft}`);
		document.documentElement.style.setProperty('--smx-container-margin-nagative', `-${marginLeft}`);
		document.documentElement.style.setProperty('--smx-container-width', `${width}`);
	}

}

function setRealVhValue(){
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export default { init };